import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { colorClassName, modifier, } from "../modifiers/index.js";
export const Navbar = ({ children, className, color, isTransparent, hasShadow, ...props }) => {
    const _class = classNames("navbar", colorClassName(color), modifier({ hasShadow, isTransparent }), className);
    return (_jsx("nav", { className: _class, ...props, children: children }));
};
export const NavbarBrand = ({ children, className, ...props }) => {
    const _class = classNames("navbar-brand", className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const NavbarDivider = () => _jsx("hr", { className: "navbar-divider" });
export const NavbarBurger = ({ className, isActive, setIsActive, ...props }) => {
    const _class = classNames("navbar-burger", className);
    const onClick = (event) => {
        event.stopPropagation();
        setIsActive((isActive) => !isActive);
    };
    return (_jsxs("div", { "aria-expanded": isActive ? "true" : "false", "aria-label": "menu", role: "button", className: _class, onClick: onClick, ...props, children: [_jsx("span", { "aria-hidden": "true" }), _jsx("span", { "aria-hidden": "true" }), _jsx("span", { "aria-hidden": "true" })] }));
};
export const NavbarDropdown = ({ children, className, ...props }) => {
    const _class = classNames("navbar-dropdown", className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const NavbarEnd = ({ children, className, ...props }) => {
    const _class = classNames("navbar-end", className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const NavbarItem = ({ children, className, hasDropdown, hasDropdownUp, isActive, isExpanded, isHoverable, isTab, ...props }) => {
    const _class = classNames("navbar-item", modifier({
        hasDropdown,
        hasDropdownUp,
        isActive,
        isExpanded,
        isHoverable,
        isTab,
    }), className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const NavbarItemAnchor = ({ children, className, isActive, ...props }) => {
    const _class = classNames("navbar-item", modifier({ isActive }), className);
    return (_jsx("a", { className: _class, ...props, children: children }));
};
export const NavbarLink = ({ children, className, ...props }) => {
    const _class = classNames("navbar-link", className);
    return (_jsx("a", { className: _class, ...props, children: children }));
};
export const NavbarMenu = ({ children, className, isActive, }) => {
    const _class = classNames("navbar-menu", modifier({ isActive }), className);
    return _jsx("div", { className: _class, children: children });
};
export const NavbarStart = ({ children, className, }) => {
    const _class = classNames("navbar-start", className);
    return _jsx("div", { className: _class, children: children });
};
